/**
 * BMI Calculator
 */
export default class BmiCalculator {
	constructor() {
		/**
		 * DOM Selectors
		 * @type {{acceptAllLabel: string, bmiCalculate: string, acceptLabel: string}}
		 */
		this.DOM = {
			bmiCalculate: ".c-bmi-calculator",
		};

		this.bmiCalculate = document.querySelector(this.DOM.bmiCalculate);
	}

	/**
	 * Init
	 */
	init() {
		if (this.bmiCalculate === null) {
			return;
		}
		this.bmiCalc();
	}

	/**
	 * Calculate BMI
	 */
	bmiCalc() {
		var height = document.getElementById("height");
		var weight = document.getElementById("weight");
		var form = document.getElementById("form");

		function validateForm() {
			if (height.value == '' || weight.value == '') {
				document.getElementById("submit").removeEventListener("click", countBmi);
			} else {
				countBmi();
			}
		}

		document.getElementById("submit").addEventListener("click", validateForm);

		function countBmi() {
			var p = [height.value, weight.value];
			var quarterAdd = 0;
			var bmiStepPercentage = 0;
			var graphRotateEl = document.getElementById('bmi_calc_arrow');
			var bmi = Number(p[1]) / (Number(p[0]) / 100 * Number(p[0]) / 100);
			var bmiResult = parseFloat(bmi).toFixed(2);
			var gender = document.querySelector('.c-form__fieldset--radio input[name="gender"]:checked').value; // formula is: [ ( BMI - lower limit ) / ( higher limit - lower limit ) ] * 45 -> last 45 is quarter of circle in degree

			if (bmi > 45) {
				var degree = 172;
			} else if (bmi < 10) {
				var degree = 8;
			} else {
				if (gender === 'm') {
				if (bmi < 19.9) {
					quarterAdd = 0;
					bmiStepPercentage = bmi - 10;
					bmiStepPercentage = bmiStepPercentage / 19.9 * 45;
				} else if (19.9 <= bmi && bmi <= 26.9) {
					quarterAdd = 45;
					bmiStepPercentage = bmi - 19.9;
					bmiStepPercentage = bmiStepPercentage / 7 * 45;
				} else if (27 <= bmi && bmi <= 34.9) {
					quarterAdd = 90;
					bmiStepPercentage = bmi - 27;
					bmiStepPercentage = bmiStepPercentage / 7.9 * 45;
				} else if (35 <= bmi) {
					quarterAdd = 135;
					bmiStepPercentage = bmi - 35;
					bmiStepPercentage = bmiStepPercentage / 15 * 45;
				}
				} else if (gender === 'z') {
				if (bmi < 18.5) {
					quarterAdd = 0;
					bmiStepPercentage = bmi - 10;
					bmiStepPercentage = bmiStepPercentage / 18.5 * 45;
				} else if (18.5 <= bmi && bmi <= 24.9) {
					quarterAdd = 45;
					bmiStepPercentage = bmi - 18.5;
					bmiStepPercentage = bmiStepPercentage / 6.4 * 45;
				} else if (25 <= bmi && bmi <= 29.9) {
					quarterAdd = 90;
					bmiStepPercentage = bmi - 25;
					bmiStepPercentage = bmiStepPercentage / 4.9 * 45;
				} else if (30 <= bmi) {
					quarterAdd = 135;
					bmiStepPercentage = bmi - 30;
					bmiStepPercentage = bmiStepPercentage / 20 * 45;
				}
				}

				var degree = quarterAdd + bmiStepPercentage;
			}

			document.getElementById('bmi_calc_result').innerHTML = bmiResult;
			graphRotateEl.style.webkitTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.mozTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.msTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.oTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.transform = 'rotate(' + degree + 'deg)';
		}
	}
}
